import Router from 'next/router';
import Svg from 'components/label/Svg';
import Chevron from '/static/icons/left-chevron.svg';
import { Mixpanel } from 'utilities/mixpanel';

export default ({ children, loading }) => (
  <div
    className="back-chevron"
    onClick={() => {
      Mixpanel.track('Clicked Back Chevron');
      !loading && Router.back();
    }}
  >
    <Svg className={`chevron-image ${!loading && `svg-shadow-hover`}`} src={Chevron} />

    <style jsx="true">{`
      .back-chevron {
        position: fixed;
        left: 26px;
        top: 50%;
      }

      .chevron-image {
        width: 23px;
        height: 43px;
      }

      @media all and (max-width: 500px) {
        .back-chevron {
          position: static;
          left: 26px;
          top: 50%;
        }

        .chevron-image {
          width: 12px;
          height: 21px;
        }
      }
    `}</style>
  </div>
);
